<template><!--个人中心》我的钱包》充值记录-->
    <div class="rechargeRecord">
        <div class="transaction-tips">
            <div class="transaction-record-title">交易查找</div>
            <div class="deal-found-type">
                <el-select v-model="founfType" placeholder="请选择" @change="choosestatus">
                    <el-option
                        style="color: #333333;"
                        v-for="(item,index) in foundtypeData"
                        :key="index"
                        :label="item"
                        :value="index"
                    ></el-option>
                </el-select>
            </div>
            <div class="found-time-box">
                <el-date-picker
                    v-model="value2"
                    type="datetimerange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    align="right"
                    @change = "pickerReadClick"
                ></el-date-picker>
            </div>
        </div>
        <div class="deal-top-box">
            <div class="deal-top-time">金额</div>
            <div class="deal-top-type">状态</div>
            <div class="deal-top-summary">支付时间</div>
            <div class="deal-top-money">操作</div>
        </div>
        <div v-if="rechargeList.length > 0">
            <div v-for="(item,index) in rechargeList" :key="index">
                <div class="deal-order-box">
                    <div class="deal-order-left">
                        <!-- <el-checkbox v-model="checked">全选</el-checkbox> -->
                        <div class="deal-order-num">
                            订单编号：
                            <span>{{item.rechargeNo}}</span>
                        </div>
                    </div>
                    <div class="deal-order-right">订单创建日期 : {{item.addTime}}</div>
                </div>
                <div class="deal-bigbox">
                    <div class="deal-order-item">
                        <div class="deal-order-time">
                            <div class="deal-order-year">{{item.price}}元</div>
                            <!-- <div class="deal-order-day">09:25:02</div> -->
                        </div>
                        <div class="deal-order-type" v-if="item.status==2">支付成功</div>
                        <div class="deal-order-type" v-if="item.status==3">支付失败</div>
                        <div class="deal-order-type" v-if="item.status==1">未支付</div>
                        <div class="deal-order-text">{{item.addTime}}</div>
                        <div class="deal-order-price">
                            <div
                                @click="contPay(item.qrCode,item.price)"
                                style="cursor: pointer;"
                                v-if="item.status==1"
                            >去支付</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else style="text-align:center;line-height:350px">暂无数据</div>
        <div class="list-page dis-end myBalance-pagination" style="margin-top:24px">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="totalLength"
            >
            </el-pagination>
        </div>
        <!----------------------------------------------------------->
        <!-- 扫码支付 -->
        <div class="orderpay" v-show="submitFlag">
            <div class="pay-code-box">
                <div class="pay-code-content">
                    <div class="pay-code-top">
                        <p>付款</p>
                        <p @click="closeCode">×</p>
                    </div>
                    <div class="pay-code-price">
                        金额:
                        <span>￥{{totalprice}}</span>
                    </div>
                    <div class="pay-code-tips">请使用以下支付方式扫码付款</div>
                    <div class="paytype-item">
                        <img src="../../../assets/image/img/购物车/sub-gs.png" alt />
                        <img src="../../../assets/image/img/购物车/sub-wx.png" alt />
                        <img src="../../../assets/image/img/购物车/sub-zfb.png" alt />
                    </div>
                    <!-- 支付二维码 -->
                    <div style="text-align:center">
                        <vue-qr :text="qr_text" :size="150" />
                    </div>
                    <!-- <div v-else class="pay-code" id="qrcode" ref="qrcode"></div> -->
                    
                    <div class="success-btn" @click="paySuccess">支付完成</div>
                </div>
            </div>
        </div>




    </div>
</template>

<style scoped>
    .myBalance-pagination >>> .el-pagination .btn-prev {margin-right: 5px;}
    .orderpay {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .paysuccess {
        width: 9.375rem;
        height: 1.875rem;
        border-radius: 5px;
        text-align: center;
        font-size: 0.875rem;
        font-weight: 400;
        color: #ffffff;
        background-color: #37a115;
        margin: 1.25rem auto 0 auto;
        line-height: 1.875rem;
        cursor: pointer;
    }

    .success-btn {
        width: 9.375rem;
        height: 1.875rem;
        text-align: center;
        line-height: 1.875rem;
        margin: 1.25rem auto 0 auto;
        background-color: #37a115;
        color: #ffffff;
        font-size: 14px;
        border-radius: 0.3125rem;
        cursor: pointer;
    }

    .soon-pay-btn {
        width: 13.0625rem;
        height: 3.125rem;
        text-align: center;
        line-height: 3.125rem;
        color: #ffffff;
        font-size: 18px;
        background-color: #d43737;
        margin-left: 2.6875rem;
        margin-top: 2.5rem;
        cursor: pointer;
    }

    .submit-box {
        width: 65.625rem;
        display: flex;
        justify-content: flex-end;
        margin-bottom: 3.125rem;
    }

    .pay-code {
        width: 9.375rem;
        height: 9.375rem;
        /* border: 1px solid #FF0000; */
        /* border-radius: 10px; */
        margin: 1.5rem auto 0 auto;
        overflow: hidden;
    }

    .paytype-item img:nth-of-type(1) {
        width: 5.75rem;
        margin-right: 1rem;
    }

    .paytype-item img:nth-of-type(2) {
        width: 3.4375rem;
        margin-right: 1rem;
    }

    .paytype-item img:nth-of-type(3) {
        width: 3.5625rem;
    }

    .paytype-item img {
        height: 1.125rem;
    }

    .paytype-item {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.875rem;
    }

    .pay-code-tips {
        margin-top: 1.875rem;
        color: #191919;
        font-size: 17px;
        text-align: center;
    }

    .pay-code-price span {
        color: #37a115;
        font-weight: bold;
        font-size: 2.125rem;
    }

    .pay-code-price {
        font-size: 24px;
        color: #191919;
        margin-top: 1.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .pay-code-top p:nth-of-type(2) {
        font-size: 28px;
        cursor: pointer;
    }

    .pay-code-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #191919;
        font-size: 1rem;
    }

    .pay-code-content {
        width: 29.375rem;
        height: 27.5rem;
        background-color: #ffffff;
        border-radius: 0.625rem;
        border: 4px solid #b3b3b3;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 0 0.4375rem;
    }

    .pay-code-box {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.1);
        z-index: 10;
    }

    .pay-type-imgbox {
        margin-top: 15px;
    }

    .pay-type-imgbox img:nth-of-type(2) {
        margin: 0 1.25rem 0 1.25rem;
    }

    .pay-type-imgbox {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .pay-right-box p {
        color: #676767;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
    }

    .pay-right-box {
        margin-left: 6.25rem;
    }

    .pay-type-box {
        display: flex;
        height: auto;
    }

    .deal-bigbox {
        width: 100%;
        height: auto;
        background-color: #f3f3f3;
        padding: 0 1px 1px 1px;
    }

    .deal-order-item > div {
        height: 3.125rem;
        line-height: 3.125rem;
    }

    .deal-order-price {
        width: 9.875rem;
        color: #c10000;
        font-size: 16px;
    }

    .deal-order-text {
        width: 23.75rem;
        border-right: 1px dashed #e3e3e3;
    }

    .deal-order-type {
        width: 9.5625rem;
        border-right: 1px dashed #e3e3e3;
    }

    .deal-order-day {
        color: #999999;
        font-size: 12px;
        margin-top: 0.5rem;
    }

    .deal-order-year {
        margin-top: 0.625rem;
    }

    .deal-order-time {
        width: 9.8rem;
        border-right: 1px dashed #e3e3e3;
        line-height: 12px !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .deal-order-item {
        width: 100%;
        height: 5.25rem;
        background-color: #ffffff;
        display: flex;
        /* justify-content: space-between; */
        align-items: center;
        font-size: 14px;
        color: #333333;
        text-align: center;
        font-weight: 400;
        margin-bottom: 0.5rem;
    }

    .deal-order-num span {
        color: #069338;
    }

    .deal-order-num {
        display: flex;
        align-items: center;
        margin-left: 2.5rem;
    }

    .deal-order-left {
        color: #666666;
        font-size: 12px;
    }

    .deal-order-left {
        display: flex;
        align-items: center;
    }

    .deal-order-box {
        height: 2.25rem;
        background-color: #f3f3f3;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #666666;
        font-size: 12px;
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .deal-order-left .el-checkbox__inner {
        width: 14px;
        height: 14px;
    }

    .deal-top-money {
        width: 9.875rem;
        text-align: center;
    }

    .deal-top-summary {
        width: 24rem;
        border-right: 1px solid #cecece;
        text-align: center;
    }

    .deal-top-type {
        text-align: center;
    }

    .deal-top-type {
        width: 9.625rem;
        border-right: 1px solid #cecece;
    }

    .deal-top-time {
        width: 6.6875rem;
        border-right: 1px solid #cecece;
    }

    .deal-top-box {
        width: 100%;
        height: 3.5rem;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        color: #333333;
        font-size: 14px;
        font-weight: 400;
        padding: 0 3.125rem;
        border: 1px solid #f3f3f3;
    }

    .found-time-box {
        /* width: 16.875rem; */
        height: 2.1875rem;
    }

    .deal-found-btn {
        width: 6.5rem;
        height: 2.1875rem;
        background-color: #37a115;
        color: #ffffff;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        line-height: 2.1875rem;
        margin-left: 0.625rem;
        cursor: pointer;
    }

    .deal-found-type {
        width: 6.75rem;
        height: 2.1875rem;
        margin-right: 0.625rem;
    }

    .deal-found-type >>> .el-input__icon {line-height: 35px;}

    .transaction-record-title {
        width: 6.75rem;
        height: 2.0625rem;
        line-height: 2.0625rem;
        text-align: center;
        background-color: #ffffff;
        position: absolute;
        top: -1.0313rem;
        left: 1.875rem;
        color: #333333;
        font-size: 16px;
    }

    .transaction-tips {
        /* width: 53.5rem; */
        width: 100%;
        height: 4.25rem;
        border: 1px solid #ebebeb;
        position: relative;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 1.875rem;
        margin-bottom: 1rem;
    }
</style>

<script>
    import vueQr from "vue-qr"
    export default
    {
        name: 'rechargeRecord',
        props: { parentName: { type: Object } },
        data()
        {
            return {
                foundtypeData: [
                    "全部",
                    "下单失败",
                    "未支付",
                    "支付成功",
                    "支付失败"
                ],
                founfType: "全部",
                pickerOptions: {
                    shortcuts: [
                        {
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 7
                                )
                                picker.$emit("pick", [start, end])
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 30
                                )
                                picker.$emit("pick", [start, end])
                            }
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 90
                                )
                                picker.$emit("pick", [start, end])
                            }
                        }
                    ]
                },
                titleType: 0,
                value2: "",
                rechargeList: [], //充值记录

                qr_text: "",
                totalprice: 0,
                submitFlag: false,
                DateStart: '',
                DateEnd: '',
                pageNo: 1,
                totalPage: 0, //总页数
                pageSize: 5,
                totalLength: 0, //总条数
                currentPage: 1,

                //+--------------------------------------------------------
                bol: false,
            };
        },
        components: {
            vueQr,
        },
        created()
        {
            this.init()
        },
        methods:
        {
            init() {
                this.getRechargeList(null)
            },
            choosestatus(index, val) {
                if (!val) {
                    this.pageNo = 1
                    this.currentPage = 1
                    this.totalLength = 0
                }
                this.titleType = index
                if (index == 0) {
                    this.getRechargeList(null)
                } else if (index == 1) {
                    this.getRechargeList(0)
                } else if (index == 2) {
                    this.getRechargeList(1)
                } else if (index == 3) {
                    this.getRechargeList(2)
                } else {
                    this.getRechargeList(3)
                }
            },
            getRechargeList(status) {
                //充值记录
                this.$loading()
                let params = {
                    PageNo: this.pageNo,
                    PageSize: this.pageSize,
                    Params: {
                        DateStart: this.DateStart,
                        DateEnd: this.DateEnd,
                        Status: status
                    }
                }
                this.$api.order.getUserRechargeList(params).then(res => {
                    this.$loading().close()
                    if (res.data.code == 0) {
                        this.rechargeList = res.data.result.data

                        let totalcount = res.data.result.totalCount;
                        this.totalLength = totalcount;
                        // 计算一共有几页
                        this.totalPage = Math.ceil( totalcount / this.pageSize );
                        // 计算得0时设置为1
                        this.totalPage = this.totalPage == 0 ? 1 : this.totalPage;
                    } else {
                        this.checkTips(res.data.message, "warning")
                    }
                })
            },
            closeCode() {
                this.submitFlag = false
            },
            contPay(code, price) {
                //充值记录去支付
                this.totalprice = price
                if (code != "") {
                    this.submitFlag = true
                    this.qr_text = code
                }
            },
            paySuccess() {
                this.submitFlag = false
                this.getRechargeList()
            },
            pickerReadClick() {
                if (this.value2 == null) {
                    this.DateStart = ''
                    this.DateEnd = ''
                    this.choosestatus(this.titleType)
                    return
                }

                this.pageNo = 1
                this.DateStart = this.formatDate(this.value2[0])
                this.DateEnd = this.formatDate(this.value2[1])
                this.choosestatus(this.titleType, 1)
            },
            //将中国标准时间转换为年月日格式
            formatTen(num) { 
                return num > 9 ? (num + "") : ("0" + num); 
            },
            formatDate(date) { 
                var year = date.getFullYear(); 
                var month = date.getMonth() + 1; 
                var day = date.getDate(); 
                var hour = date.getHours(); 
                var minute = date.getMinutes(); 
                var second = date.getSeconds(); 
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day)+ " " + this.formatTen(hour)+ ":" + this.formatTen(minute)+ ":" + this.formatTen(second); 
            },
            handleSizeChange( val )
            {
                console.log( `每页 ${val} 条` );
            },
            handleCurrentChange( val )
            {
                this.pageNo = val;
                this.choosestatus(this.titleType, 1)
                // console.log( `当前页: ${val}` );
            },
            checkTips( name, type )
            {
                this.$message(
                {
                    message: name,
                    type: type
                } );
            },
            // +--------------------------------------
            closeaddress(val)
            {
                this.$emit( 'childFn', val )
            }
        }
    }
</script>